import React, { useState } from 'react';

import { useTranslation } from 'hooks';
import BookingFlowLoadingIndicator from 'BookingFlow/components/BookingFlowLoadingIndicator';
import { ReasonForStay } from '.';

export default function ChangeReasonForStay({
	stayReasons,
	preArrivalPreferences,
	updateStayReasons,
	goBackHandler,
}) {
	const { t } = useTranslation();

	const preferencesStayReasonIds = preArrivalPreferences?.stayReasonIds || [];
	const preferencesComments = preArrivalPreferences?.comments || '';

	const [reasonForStayValues, setReasonForStayValues] = useState(preferencesStayReasonIds);
	const [commentsState, setCommentsState] = useState(preferencesComments);

	const updateReasonForStayValues = evt => {
		const { name, checked } = evt.target;

		setReasonForStayValues(prev => {
			if (checked && prev.length < 3) {
				return [...prev, name];
			}
			if (!checked) {
				return prev.filter(id => id !== name);
			}
			return prev;
		});
	};

	const handleCommentsChange = commentStr => {
		setCommentsState(commentStr);
	};

	const handleSubmit = ({ comments }) => {
		const newReasonForStayValues = reasonForStayValues.filter(Boolean);

		const idsAreDifferent =
			preferencesStayReasonIds.length !== newReasonForStayValues.length ||
			preferencesStayReasonIds.some(id => !newReasonForStayValues.includes(id));

		const commentsAreDifferent = comments !== preferencesComments;

		if (idsAreDifferent || commentsAreDifferent) {
			const updateData = {};

			if (idsAreDifferent) {
				updateData.stayReasonIds = newReasonForStayValues;
			}

			if (commentsAreDifferent) {
				updateData.comments = comments || '';
			}

			updateStayReasons(updateData);
		} else {
			goBackHandler();
		}
	};

	const isLoading = false;
	return (
		<>
			{isLoading && <BookingFlowLoadingIndicator />}
			{!isLoading && (
				<div className="change-detail-modal">
					<div className="change-detail-modal__header">
						<div className="change-detail-modal__title">{t('Reason For Stay')}</div>
						<p className="change-detail-modal__copy">
							{t('To better personalize your experience, let us know the occasion for your stay.')}
						</p>
					</div>
					<ReasonForStay
						stayReasons={stayReasons}
						selectedStayReasonIds={reasonForStayValues}
						comments={commentsState}
						onCheckboxChange={updateReasonForStayValues}
						onCommentsChange={handleCommentsChange}
						onSubmit={handleSubmit}
					/>
				</div>
			)}
		</>
	);
}
